exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".bottom-buttons__bottom-button__be5nU{background-color:rgba(0,0,0,.2);border:1px solid #fff;border-radius:0;height:38px;font-size:12px;color:#fff}.bottom-buttons__bottom-button__be5nU+.bottom-buttons__bottom-button__be5nU{border-left:none}.bottom-buttons__paid-icon__2LM3h{margin-right:5px;font-size:14px}", ""]);

// exports
exports.locals = {
	"bottom-button": "bottom-buttons__bottom-button__be5nU",
	"bottomButton": "bottom-buttons__bottom-button__be5nU",
	"paid-icon": "bottom-buttons__paid-icon__2LM3h",
	"paidIcon": "bottom-buttons__paid-icon__2LM3h"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"modules":true,"sourceMap":false,"importLoaders":1,"camelCase":true,"localIdentName":"[name]__[local]__[hash:base64:5]"}!./~/postcss-loader?{}!./~/stylus-loader?{"sourceMap":true,"resolve":true,"define":{}}!./src/widget/components/player-overlay/mobile/three-rows-widget/buttons/bottom-buttons.styl
// module id = 2921
// module chunks = 1